import React from "react";
import { IGalleryModalProps } from "./GalleryModalProps";
import Modal from "react-bootstrap/Modal";
import {
  ImageCarousel,
  NewImageCarousel,
} from "../ImageCarousel/ImageCarousel";
import { StyledModal } from "./GalleryModalHelpers";
//import { Lightbox } from "react-modal-image";

const GalleryModal: React.FC<IGalleryModalProps> = (props) => {
  const handleOnClose = () => {
    props.onClose();
  };

  return (
    <StyledModal
      show={props.show}
      onHide={handleOnClose}
      size="lg"
      centered
      aria-label="Photo Gallery"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {props.title || "Photo Gallery"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {props.newCarousel ? (
          <NewImageCarousel
            activeImage={props.activePhotoIndex || 0}
            images={props.photos}
          />
        ) : (
          <ImageCarousel
            activeImage={props.activePhotoIndex || 0}
            images={props.photos}
          />
        )}
      </Modal.Body>
    </StyledModal>
  );
};

export default GalleryModal;
